import { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import useIsMounted from '@hooks/useIsMounted'
import { RoleInfo } from '@models/role.model'
import { OptionsContext } from '@contexts/Options'
import { KeyValPair } from '@models/common.model'
import { Box, Container, Grid, MenuItem, Select, Stack, Typography } from '@mui/material'
import CustomizedAccordions from './accordion'
import CustomizedSearch from './search'
import DialogSearch from './select'

export default function DialogContent({
	list,
	options,
	selectedGroups,
	setSelectedGroups,
	handleSearchRolesByProject,
	handleInputSearch,
	setInputValueSearched,
	inputValueSearched,
}: {
	list: any
	options: KeyValPair[]
	selectedGroups: string[]
	setSelectedGroups: any
	handleSearchRolesByProject: any
	handleInputSearch: any
	setInputValueSearched: any
	inputValueSearched: any
}) {
	const { control } = useFormContext()

	return (
		<Box sx={{ padding: '0' }}>
			<Grid
				container
				sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: '60px' }}
			>
				<Grid item xs={5.2} sx={{ marginX: '30px' }}>
					<CustomizedSearch
						value={[]}
						sx={{ width: '100%', height: '100%' }}
						handleInputSearch={handleInputSearch}
						handleOnSearch={(selectedValue) => {}}
						setInputValueSearched={setInputValueSearched}
						inputValueSearched={inputValueSearched}
					/>
				</Grid>
				<Box sx={{ width: '1px', minHeight: '60px', backgroundColor: '#D3D3D3' }} />
				<Grid item xs={4.8} sx={{ marginX: '30px' }}>
					<DialogSearch
						options={options}
						handleSearchRolesByProject={handleSearchRolesByProject}
						placeholder={'Pease Select Project'}
					/>
				</Grid>
			</Grid>
			<Stack>
				<CustomizedAccordions
					list={list}
					selectedGroups={selectedGroups}
					setSelectedGroups={setSelectedGroups}
				/>
			</Stack>
		</Box>
	)
}
